class RingBuilderStep3 {
  constructor() {
    this.cartManager = new ShopifyCartManager();
    this.spinnerOverlayManager = new LBDOverlaySpinnerManager();
    this.apiBaseUrl = 'https://api.lovebydeccla.com';

    this.conversionRate =
      Shopify.currency.active !== "AUD" ? Shopify.currency.rate : 1;

    // Initialize the media loader
    this.mediaLoader = new LbdDsrbMediaLoader();

    this.productContainer = document.querySelector(
      ".product.product--medium.product--left"
    );

    this.content = document.getElementById("content");

    this.ringMainImage = document.getElementById("ring-main-image");
    this.diamondVideoContainer = document.getElementById(
      "diamond-video-container"
    );
    this.diamondImage = document.getElementById("diamond-image");
    this.ringSecondaryImage = document.getElementById("ring-secondary-image");

    this.ringNameElement = document.getElementById("ring-name");
    this.diamondNameElement = document.getElementById("diamond-name");
    this.combinedDetailsElement = document.getElementById("combined-details");
    this.totalPriceElement = document.getElementById("total-price");
    this.addToCartElement = document.getElementById("add-to-cart");
    this.shippingInfoElement = document.getElementById("shipping-info");

    this.ringInfoElement = document.getElementById("ring-info");
    this.diamondInfoElement = document.getElementById("diamond-info");

    this.detailsAccordionElement = document.getElementById("details-accordion");

    this.sizeErrorElement = null;

    this.diamond = null;
    this.ring = null;
    this.totalPrice = null;
    this.mobileBreakpoint = 768; //bootstrap md. 

    let wasMobile = window.innerWidth < this.mobileBreakpoint;
    window.addEventListener('resize', () => {
      const isMobile = window.innerWidth < this.mobileBreakpoint;
      // only when we newly enter “mobile” do we rebuild the slides
      if (isMobile && !wasMobile) {
        this.setupMobileSlideshow();
      }
      wasMobile = isMobile;
    });
    this.init();
  }

  async init() {
    try {
      this.spinnerOverlayManager.show();
      await this.loadDataFromLocalStorage();

      if (!this.diamond || !this.ring) {
        this.showMissingDataMessage();
      } else {

        // Validate diamond exists in the API
        const diamondExists = await this.validateDiamond();

        if (!diamondExists) {

          // Clear local storage and show diamond not available message
          localStorage.removeItem("selectedDiamond");
          this.showDiamondNotAvailable();
          return; // Exit early
        }

        this.convertCurrency();
        this.displayRingBuilderDetails();
        this.populateRingSizes();
      }

      requestAnimationFrame(() => {
        this.spinnerOverlayManager.hide();
        this.content.style.display = "block";

        const infoEl = document.getElementById("ring-builder-info");
        if (infoEl) {
          infoEl.scrollIntoView({ behavior: "smooth", block: "start" });
        }


        this.setupEventListeners();
        this.setupMediaWithLoader();
        if (window.innerWidth < this.mobileBreakpoint) {
          this.setupMobileSlideshow();
        }
      });
    } catch (error) {
      console.error("Error:", error);
      this.showError(error.message);
      this.spinnerOverlayManager.hide();
    }
  }

  async validateDiamond() {
    try {

      const response = await fetch(`${this.apiBaseUrl}/diamonds/${this.diamond['id']}`);
      if (!response.ok) {
        // If we get a 404, the diamond doesn't exist
        if (response.status === 404) {
          // console.error('Diamond not found in inventory');
          return false;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.success && data.data) {
        const apiDiamond = data.data;
        if (
          parseFloat(apiDiamond.price) === parseFloat(this.diamond.price) &&
          apiDiamond.carat === this.diamond.carat &&
          apiDiamond.shape === this.diamond.shape
        ) {
          return true;
        } else {
          // Diamond exists but data mismatch - treat as not available
          // console.warn('Diamond data mismatch');
          return false;
        }
      }

      return false;
    } catch (error) {
      console.error('Error validating diamond:', error);
      // In case of network error or other issues, we could either:
      // 1. Return false (treat as not available)
      // 2. Return true (allow to proceed)
      // 3. Show a different error message
      // For now, let's treat network errors as diamond not available
      return false;
    }
  }

  showDiamondNotAvailable() {
    // Hide the spinner
    this.spinnerOverlayManager.hide();

    // Clear the content container and show it
    this.content.innerHTML = '';
    this.content.style.display = 'block';

    // Create the alert message
    const alertHTML = `
      <div class="alert alert-warning" role="alert">
        <h1 class="alert-heading">Diamond No Longer Available</h1>
        <p>We're sorry, this diamond is no longer available. Our collection holds many other captivating diamonds that you may also love.</p>
        <p>Explore our current selection of diamonds and engagement rings to find the perfect match for you.</p>
        <div style="display: flex; padding-top: var(--lbd-large-margin)">
          <a href="/collections/engagement-rings" class="alert-link lbd-icon-diagonal-arrow">Engagement Rings ${window.diagonalarrowSvgContent || ''}</a>
          <div style="padding-left: var(--lbd-minor-margin); padding-right: var(--lbd-minor-margin); margin-top: -1px; color: var(--lbd-text-dark-color)">|</div>
          <a href="/pages/diamonds" class="alert-link lbd-icon-diagonal-arrow">Diamond Search ${window.diagonalarrowSvgContent || ''}</a>
        </div>
      </div>
    `;

    // Insert the alert into the content container
    this.content.innerHTML = alertHTML;
  }

  async loadDataFromLocalStorage() {
    this.diamond = JSON.parse(localStorage.getItem("selectedDiamond"));
    this.ring = JSON.parse(localStorage.getItem("selectedRing"));
  }

    showRingSizeError(message) {
    if (!this.sizeErrorElement) return;
    this.sizeErrorElement.textContent = message;
    this.sizeErrorElement.style.display = 'block';
  }

  clearRingSizeError() {
    if (!this.sizeErrorElement) return;
    this.sizeErrorElement.textContent = '';
    this.sizeErrorElement.style.display = 'none';
  }

  setupMobileSlideshow() {
    // collect nodes
    this.mobileSlides = Array.from(
      document.querySelectorAll(".lbd-slideshow-image")
    );
    this.mobileDots = Array.from(
      document.querySelectorAll(".lbd-slideshow-dot")
    );

    document
      .getElementById("ring-main-image-mobile")
      .setAttribute("src", this.ring.mainImage);
    document
      .getElementById("ring-main-image-mobile")
      .setAttribute("alt", `${this.ring.name} – Main`);

    document
      .getElementById("diamond-image-mobile")
      .setAttribute("src", this.diamond.image);
    document
      .getElementById("diamond-image-mobile")
      .setAttribute("alt", `${this.diamond.carat} Carat ${this.diamond.shape}`);

    document
      .getElementById("ring-secondary-image-mobile")
      .setAttribute("src", this.ring.secondaryImage);
    document
      .getElementById("ring-secondary-image-mobile")
      .setAttribute("alt", `${this.ring.name} – Secondary`);

    const videoSlide = document.querySelector(
      '[data-lbd-slide-id="diamond-video"]'
    );
    const videoContainer = document.getElementById("diamond-video-mobile");

    // Clear the container first
    videoContainer.innerHTML = "";

    // Create a dynamic media container (matching desktop structure)
    let dynamicMediaContainer = videoContainer.querySelector(
      ".dynamic-media-container"
    );
    if (!dynamicMediaContainer) {
      dynamicMediaContainer = document.createElement("div");
      dynamicMediaContainer.className =
        "dynamic-media-container d-none position-absolute top-0 start-0 w-100 h-100";
      dynamicMediaContainer.style.zIndex = "3";
      videoContainer.appendChild(dynamicMediaContainer);
    }

    // Create placeholder image (matching desktop structure)
    const placeholderImg = document.createElement("img");
    placeholderImg.style.visibility = "hidden";
    placeholderImg.className = "position-absolute top-0 start-0 w-100 h-100";
    placeholderImg.style.objectFit = "cover";
    placeholderImg.style.zIndex = "2";
    placeholderImg.addEventListener("load", () => {
      placeholderImg.style.visibility = "visible";
    });
    placeholderImg.src = this.diamond.image;
    placeholderImg.alt = `${this.diamond.carat} Carat ${this.diamond.shape} Diamond`;
    videoContainer.appendChild(placeholderImg);

    // Set up media interaction with the same structure as desktop
    this.mediaLoader.setupMediaInteraction(
      this.diamond,
      videoContainer,
      placeholderImg,
      dynamicMediaContainer
    );

    setTimeout(() => {
      const firstDot = document.querySelector(".lbd-slideshow-dot");
      if (firstDot) {
        firstDot.click();
      }
    }, 100);
  }



  showMobileSlide(newIndex) {
    this.mobileSlides.forEach((slide, idx) => {
      slide.classList.toggle("active", idx === newIndex);
      slide.classList.toggle("previous", idx === this.currentMobileIndex);
    });
    this.mobileDots.forEach((dot, idx) => {
      dot.classList.toggle("active", idx === newIndex);
    });
    this.currentMobileIndex = newIndex;
  }

  showMissingDataMessage() {
    if (this.productContainer) {
      this.productContainer.innerHTML = `
                <div class="alert alert-warning" role="alert">
                    <h1 class="alert-heading">Missing Information</h1>
                    <p>We're sorry, it seems some information is missing. Please ensure you've selected both a ring and a diamond before continuing.</p>
                    <div style="display: flex; padding-top: var(--lbd-large-margin)">
                      <a href="/collections/engagement-rings" class="alert-link lbd-icon-diagonal-arrow">Engagement Rings ${diagonalarrowSvgContent}</a>
                      <div style="padding-left: var(--lbd-minor-margin); padding-right: var(--lbd-minor-margin); margin-top: -1px; color: var(--lbd-text-dark-color)">|</div>
                      <a href="/pages/diamonds" class="alert-link lbd-icon-diagonal-arrow">Diamonds ${diagonalarrowSvgContent}</a>
                    </div>
                </div>
            `;
    }

  }

  convertCurrency() {
    if (this.conversionRate !== 1) {
      this.diamond.price = (
        parseFloat(this.diamond.price) * this.conversionRate
      ).toFixed(2);
      this.ring.price = (
        parseFloat(this.ring.price) * this.conversionRate
      ).toFixed(2);
    }
  }

  displayRingBuilderDetails() {

    function getShippingEstimateDate(days1Diamond = 14, days2RingSetting = 21) {
      const totalDays =
        Math.max(0, parseInt(days1Diamond) || 0) +
        Math.max(0, parseInt(days2RingSetting) || 0);

      const today = new Date();
      let currentDate = new Date(today);
      let businessDaysAdded = 0;

      while (businessDaysAdded < totalDays) {
        currentDate.setDate(currentDate.getDate() + 1);

        const dayOfWeek = currentDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          businessDaysAdded++;
        }
      }

      const options = { day: "numeric", month: "long", year: "numeric" };
      return currentDate.toLocaleDateString("en-AU", options);
    }

    function parseAccentDiamonds(description) {
      if (!description) return "";
      const diamondPattern = /(?:(?:[xX×]\s*(\d+))|(?:(\d+)\s*[xX×]))\s+([A-Za-z]+)\s+([\d.]+)\s*ct/gi;
      let totalQuantity = 0;
      let totalCarats = 0;
      const shapes = new Set();
      let match;
      while ((match = diamondPattern.exec(description)) !== null) {
        const quantity = parseInt(match[1] || match[2], 10);
        const shape = match[3];
        const carats = parseFloat(match[4]);
        if (!Number.isFinite(quantity) || !Number.isFinite(carats)) continue;
        totalQuantity += quantity;
        totalCarats += carats * quantity;
        shapes.add(shape);
      }
      if (totalQuantity === 0) return description;
      const shapeText = shapes.size === 1 ? [...shapes][0] : [...shapes].join('/');
      return `${shapeText} Accent Diamonds of approximately ${totalCarats.toFixed(2)}ct. May vary by ring size.`;
    }

    if (this.diamond && this.ring) {
      this.setupMediaContainers();

      // Ring details
      document.getElementById("ring-name").textContent = `${this.ring.name}`;
      document.getElementById("ring-price").textContent = `${Shopify.currency.active
        } ${parseFloat(this.ring.price).toLocaleString()}`;
      document.getElementById("ring-details").innerHTML = `
              <div style="display: flex; justify-content: space-between; align-items: center;">
                ${this.ring.design} ${this.ring.desc_number_of_prongs || ""} ${this.ring.desc_prong_type || ""
        } in ${this.ring.selectedVariant?.option1}
                <div style="display: flex; align-items: center;">
                  <a data-title="Remove" href="#" onclick="window.ringBuilder.changeSelection('ring');return false;" class="lbd-minor-link">${replaceleftSvgContent}</a>
                  <a data-title="View" href="${this.ring.url}${this.ring.selectedVariantId
          ? `?variant=${this.ring.selectedVariantId}`
          : ""
        }" class="lbd-minor-link">${viewleftSvgContent}</a>
                </div>
              </div>
            `;

      // Diamond details
      document.getElementById(
        "diamond-name"
      ).textContent = `${this.diamond.carat} Carat ${this.diamond.shape} Diamond`;
      document.getElementById("diamond-price").textContent = `${Shopify.currency.active
        } ${parseFloat(this.diamond.price).toLocaleString()}`;
      document.getElementById("diamond-details").innerHTML = `
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div style="display: flex; align-items: center; gap: var(--lbd-standard-margin);">
                ${this.diamond.color || ""} Color, ${this.diamond.clarity || ""
        } Clarity, ${this.diamond.cut || ""} Cut

                <div class="badge-container">
                  ${(this.diamond.triple_x === true
          ? `<div class="badge-item triple-x-item" style="display: flex;">${starSvgContent} <span>Triple Excellent</span></div>`
          : "") +
        (this.diamond.hearts_and_arrows === true
          ? `<div class="badge-item hearts-arrows-item" style="display: flex;">${heartSvgContent} <span>Hearts and Arrows</span></div>`
          : "")
        }
                </div>
                </div>
                
                <div style="display: flex; align-items: center;">
                  <a data-title="Remove" href="#" onclick="window.ringBuilder.changeSelection('diamond');return false;" class="lbd-minor-link">${replaceleftSvgContent}</a>
                  <a data-title="View" href="/pages/diamond-details?id=${this.diamond.id
        }" class="lbd-minor-link">${viewleftSvgContent}</a>
                </div>          
              </div>
            `;

      // Total price
      this.totalPrice =
        parseFloat(this.diamond.price) + parseFloat(this.ring.price);
      this.totalPriceElement.innerHTML = `
                <div class="card card-price">
                   <div class="card-body">
                       <div style="display: flex; justify-content: space-between;">
                           <div style="display: flex; align-items: center;">
                               <span class="h4" style="padding-right: var(--lbd-minor-margin);">Total Price</span>
                               <span id="total-sum">${Shopify.currency.active
        } ${this.totalPrice.toLocaleString()}</span>
                           </div>
                           <div>
                               <span class="card-text lbd-minor-text-color">Taxes Included.</span>
                           </div>
                       </div>
                       <div style="display: flex; justify-content: space-between; margin-top: var(--lbd-minor-margin);">
                           <div style="display: flex; align-items: center;">
                               <span class="h4" style="padding-right: var(--lbd-minor-margin);">Estimated Delivery</span>
                               <span id="shipping-date">${getShippingEstimateDate(
          this.diamond.shipping_est_days + 21
        )}</span>
                           </div>
                           <div>
                               <span class="card-text lbd-minor-text-color">Free Shipping.</span>
                           </div>
                       </div>
                       <div class="afterpay-message-position"></div>
                   </div>
                </div>
            `;

      // Add to cart button
      this.addToCartElement.innerHTML = `
                <div class="form-group" style="padding-bottom: var(--lbd-minor-margin)">
                    <div style="padding-bottom: var(--lbd-minor-margin)"><label for="ring-size-select" class="h4">Ring Size</label>
                        <span class="lbd-icon-diagonal-arrow">
                        <a
                          href="/pages/ring-sizing-handbook"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="lbd-link"
                          style="display: inline-block;"
                        >
                          ${diagonalarrowSvgContent}
                        </a>
                        </span>
                    </div>

                    <div class="lbd-select-wrapper">
 
                      <select id="ring-size-select" required></select>
                    </div>

                    <p class="ring-size-error lbd-minor-text-color"
                      style="margin-top: 0.5rem; display: none;"
                      aria-live="polite"></p>

                </div>
                <div class="form-group" style="padding-bottom: var(--lbd-minor-margin)">
                    <div style="padding-bottom: var(--lbd-minor-margin)"><label for="engraving-input" class="h4">Engraving <span class="lbd-minor-text-color" style="text-transform: none !important;">(Optional, Max 10 Characters)</span></label></div>
                    <div class="field">
                      <input 
                        placeholder="Enter engraving text" 
                        type="text" class="field__input" 
                        id="engraving-input" 
                        maxlength="10"
                        >
                      <label class="field__label" for="engraving-input">
                          Enter engraving text
                      </label>
                      </div>
                </div>

                <div style="padding-top: var(--lbd-minor-margin)">
                  <button type="button" class="lbd-buy-button" id="add-to-cart-btn"">
                      Add To Bag
                  </button>
                </div>
            `;

      // // Shipping info

      // this.shippingInfoElement.innerHTML = `
      //         <ul>
      //          <li>Complementary <b>free shipping</b> on all diamond and engagement ring orders.</li>
      //          <li>Your ring is estimated to be delivered by <b>${getShippingEstimateDate(
      //            this.diamond.shipping_est_days + 21
      //          )}</b>.</li>
      //         </ul>
      //       `;

      // ——— shipping date ———
      const rawShipDays = Number(this.diamond.shipping_est_days);
      const diamondDays = Number.isFinite(rawShipDays) ? rawShipDays : 0;

      let shippingDateStr;
      try {
        shippingDateStr = getShippingEstimateDate(diamondDays, 21);
      } catch (err) {
        console.error("Error computing shipping estimate:", err);
        shippingDateStr = "TBD";
      }
      const shipDateEl = document.getElementById("shipping-date");
      if (shipDateEl) shipDateEl.textContent = shippingDateStr;

      // ——— shipping info list ———
      const shippingInfoEl = this.shippingInfoElement;
      if (shippingInfoEl) {
        shippingInfoEl.innerHTML = `
          <ul>
            <li>Complimentary shipping within Australia.</li>
            <li>Your ring is estimated to be delivered by <b>${shippingDateStr}</b>.</li>
          </ul>
        `;
      }



      this.ringInfoElement.innerHTML = `
               <ul>
                  ${this.ring.desc_diamond_cut
          ? `<li>Suitable for ${this.ring.desc_diamond_cut} Cut Diamonds.</li>`
          : ""
        }
                  ${this.ring.desc_number_of_prongs && this.ring.desc_prong_type
          ? `<li>${this.ring.desc_number_of_prongs} ${this.ring.desc_prong_type} Prong Setting.</li>`
          : ""
        }
                  ${this.ring.desc_width
          ? `<li>Shank width of ${this.ring.desc_width}mm.</li>`
          : ""
        }
                  ${this.ring.desc_accent_stones
          ? `<li>${this.ring.desc_accent_stones} Accent Setting of VVS to VS colour.</li>`
          : ""
        }
                  ${this.ring.desc_accent_stones_description
          ? `<li>${parseAccentDiamonds(this.ring.desc_accent_stones_description)}</li>`
          : ""
        }
                  <li>Recommended gemstone size of up to 6 carats.</li>
                </ul>
                
                <div class="lbd-submenu-item" style="padding-bottom: 0;">
                  <a href="${this.ring.url}${this.ring.selectedVariantId
          ? `?variant=${this.ring.selectedVariantId}`
          : ""
        }" target="blank" class="lbd-link">View Your Ring</a>
                  <span class="lbd-icon-diagonal-arrow">${diagonalarrowSvgContent}</span>
                </div>
            `;

      this.diamondInfoElement.innerHTML = `
              <div class="badge-container">
                ${(this.diamond.triple_x === true
          ? `
                    <div style="display: flex; padding-bottom: var(--lbd-minor-margin)">${starSvgContent} <span>Triple Excellent</span></div>
                    `
          : "") +
        (this.diamond.hearts_and_arrows === true
          ? `<div style="display: flex; padding-bottom: var(--lbd-minor-margin)">${heartSvgContent} <span>Hearts and Arrows</span></div>`
          : "")
        }
              </div>
              <table class="lbd-table">
                <thead>
                  <tr>
                    <th>Property</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Stone ID"></i>Stone No:</td>
                    <td>${this.diamond.id}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Certification number from the grading laboratory"></i>Certificate:</td>
                    <td>${this.diamond.lab} Report No: ${this.diamond.lab_report
        }</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Indicates the shipping method for this diamond"></i>Shipping:</td>
                    <td>${this.diamond.shipping_category}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The cut shape of the diamond"></i>Shape:</td>
                    <td>${this.diamond.shape}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Weight of the diamond (1 carat = 0.2 grams)"></i>Carat:</td>
                    <td>${this.diamond.carat}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Diamond color grade, ranging from D (colourless) to Z (light yellow or brown)"></i>Colour:</td>
                    <td>${this.diamond.color}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Grade indicating the small imperfections or inclusions in the diamond"></i>Clarity:</td>
                    <td>${this.diamond.clarity}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Grade reflecting how well the diamond is cut, affecting its sparkle"></i>Cut:</td>
                    <td>${this.diamond.cut}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Grade of the diamond's surface smoothness"></i>Polish:</td>
                    <td>${this.diamond.polish}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Grade of the diamond's proportions and alignment of facets"></i>Symmetry:</td>
                    <td>${this.diamond.symmetry}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The unwanted glow the diamond produces under UV light"></i>Fluorescence:</td>
                    <td>${this.diamond.fluorescence}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The diamond's length in millimeters"></i>Length:</td>
                    <td>${this.diamond.length} mm</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The diamond's width in millimeters"></i>Width:</td>
                    <td>${this.diamond.width} mm</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The diamond's height in millimeters"></i>Height:</td>
                    <td>${this.diamond.height} mm</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The height of a diamond from the culet to the table, expressed as a percentage of its average diameter"></i>Depth:</td>
                    <td>${this.diamond.depth}%</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The width of the diamond's top facet, expressed as a percentage of the average diameter"></i>Table:</td>
                    <td>${this.diamond.table}%</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Ratio of the diamond's length to its width"></i>Length To Width Ratio:</td>
                    <td>${this.diamond.length_to_width_ratio}</td>
                  </tr>
                  <tr>
                    <td><i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="The small flat face at the bottom of the diamond"></i>Culet:</td>
                      <td>${this.diamond.culet
          ? this.diamond.culet.charAt(0).toUpperCase() +
          this.diamond.culet.slice(1).toLowerCase()
          : ""
        }</td>
                  </tr>
                </tbody>
              </table>
              
              <div class="lbd-submenu-item" style="padding-bottom: 0; padding-top: var(--lbd-minor-margin)">
                <a href="/pages/diamond-details?id=${this.diamond.id
        }" target="blank" class="lbd-link">View Your Diamond</a>
                <span class="lbd-icon-diagonal-arrow">${diagonalarrowSvgContent}</span>
              </div>
            `;

      this.populateDetailsAccordion();
    }
  }

  populateRingSizes() {


    const manualDefinedSizes = [

      "AU G | US 3 1/4",
      "AU G 1/2 | US 3 1/2",
      "AU H | US 3 3/4",
      "AU H 1/2 | US 4",
      "AU I | US 4 1/4",
      "AU I 1/2 | US 4 1/2",
      "AU J | US 4 3/4",
      "AU J 1/2 | US 5",
      "AU K | US 5 1/4",
      "AU K 1/2 | US 5 1/2",
      "AU L | US 5 3/4",
      "AU L 1/2 | US 6",
      "AU M | US 6 1/4",
      "AU M 1/2 | US 6 1/2",
      "AU N | US 6 3/4",
      "AU N 1/2 | US 7",
      "AU O | US 7 1/4",
      "AU O 1/2 | US 7 1/2",
      "AU P | US 7 3/4",
      "AU P 1/2 | US 8",
      "AU Q | US 8 1/4",
      "AU Q 1/2 | US 8 1/2",
      "AU R | US 8 3/4",
      "AU R 1/2 | US 9",
      "AU S | US 9 1/4",
      "AU S 1/2 | US 9 1/2",

    ];

    // 2. Grab (and optionally clear) <select>:
    const ringSizeSelect = document.getElementById("ring-size-select");
    ringSizeSelect.innerHTML = ""; // remove any old options

    // disabled, hidden placeholder (works nicely with `required`)
    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = "Select your ring size";
    placeholder.selected = true;
    placeholder.disabled = true;
    placeholder.hidden = true;
    ringSizeSelect.appendChild(placeholder);

    // 3. Loop over array and append <option>s:
    manualDefinedSizes.forEach((size) => {
      const option = document.createElement("option");
      option.value = size;
      option.textContent = size;
      ringSizeSelect.appendChild(option);
    });
  }

  setupMediaContainers() {
    // grab existing elements
    this.ringMainImage = document.getElementById("ring-main-image");
    this.diamondImage = document.getElementById("diamond-image");
    this.ringSecondaryImage = document.getElementById("ring-secondary-image");
    this.diamondVideoContainer = document.getElementById(
      "diamond-video-container"
    );

    this.diamondImage.style.visibility = "hidden";
    this.diamondImage.addEventListener("load", () => {
      this.diamondImage.style.visibility = "visible";
    });
    this.diamondImage.src = this.diamond.image;
    this.diamondImage.alt = `${this.diamond.carat} Carat ${this.diamond.shape} Diamond`;

    // this.ringSecondaryImage.style.visibility = 'hidden';
    // this.ringSecondaryImage.addEventListener('load', () => {
    //     this.ringSecondaryImage.style.visibility = 'visible';
    // });

    // Set the image sources
    this.ringMainImage.src = this.ring.mainImage;
    this.ringMainImage.alt = `${this.ring.name} - Main Image`;

    this.ringSecondaryImage.src = this.ring.secondaryImage;
    this.ringSecondaryImage.alt = `${this.ring.name} - Secondary Image`;

    this.diamondVideoContainer.innerHTML = "";
    let dynamicMediaContainer = this.diamondVideoContainer.querySelector(
      ".dynamic-media-container"
    );
    if (!dynamicMediaContainer) {
      dynamicMediaContainer = document.createElement("div");
      dynamicMediaContainer.className =
        "dynamic-media-container d-none position-absolute top-0 start-0 w-100 h-100";
      dynamicMediaContainer.style.zIndex = "20";
      this.diamondVideoContainer.appendChild(dynamicMediaContainer);
    }
  }

  setupMediaWithLoader() {
    if (!this.diamond || !this.ring || !this.diamond.video) return;

    // ensure container has an ID
    if (!this.diamondVideoContainer.id) {
      this.diamondVideoContainer.id = `diamond-video-container-${this.diamond.id}`;
    }

    let dynamicMediaContainer = this.diamondVideoContainer.querySelector(
      ".dynamic-media-container"
    );
    if (!dynamicMediaContainer) {
      dynamicMediaContainer = document.createElement("div");
      dynamicMediaContainer.className =
        "dynamic-media-container d-none position-absolute top-0 start-0 w-100 h-100";
      dynamicMediaContainer.style.zIndex = "20";
      this.diamondVideoContainer.appendChild(dynamicMediaContainer);
    }

    const placeholderImg = document.createElement("img");
    placeholderImg.style.visibility = "hidden";
    placeholderImg.className = "position-absolute top-0 start-0 w-100 h-100";
    placeholderImg.style.objectFit = "cover";
    placeholderImg.style.zIndex = "10";
    placeholderImg.addEventListener("load", () => {
      placeholderImg.style.visibility = "visible";
    });
    placeholderImg.src = this.diamond.image;
    placeholderImg.alt = `${this.diamond.carat} Carat ${this.diamond.shape} Diamond`;
    this.diamondVideoContainer.appendChild(placeholderImg);

    this.mediaLoader.setupMediaInteraction(
      this.diamond,
      this.diamondVideoContainer,
      placeholderImg,
      dynamicMediaContainer
    );
  }

  populateDetailsAccordion() {

    this.detailsAccordionElement.innerHTML = `
          <ul>
          <li>If you have any questions or would like assistsance, contact our dedicated support staff. We would be delighted to help you.</li>
          <li>Visit our FAQ for commonly asked questions.</li>
          </ul>
        `;
  }

  showError(message) {
    const errorElement = document.createElement("div");
    errorElement.className = "alert alert-danger";
    errorElement.textContent = message;
    this.content.parentNode.insertBefore(errorElement, this.content);
  }

  setupEventListeners() {
    const addToCartButton = document.getElementById("add-to-cart-btn");
    if (addToCartButton) {
      addToCartButton.addEventListener("click", this.addToCart.bind(this));
    }


    // this.ringSizeSelect = document.getElementById("ring-size-select");
    // if (this.ringSizeSelect) {
    //   this.ringSizeSelect.addEventListener(
    //     "change",
    //     this.updatePrice.bind(this)
    //   );

    //   // Keep our custom message (don’t let the browser overwrite it)
    //   this.ringSizeSelect.addEventListener("invalid", () => {
    //     if (!this.ringSizeSelect.value) {
    //       this.ringSizeSelect.setCustomValidity("A perfect fit awaits — select your ring size.");
    //     }
    //   });
    //   this.ringSizeSelect.addEventListener("change", () => {
    //     this.ringSizeSelect.setCustomValidity("");
    //   });

    // }


    this.ringSizeSelect = document.getElementById("ring-size-select");
    this.sizeErrorElement = document.querySelector(".ring-size-error");

    if (this.ringSizeSelect) {
      this.ringSizeSelect.addEventListener(
        "change",
        this.updatePrice.bind(this)
      );

      // Clear error when user picks a size
      this.ringSizeSelect.addEventListener("change", () => {
        this.ringSizeSelect.setCustomValidity("");
        this.clearRingSizeError();
      });
    }


    this.engravingInput = document.getElementById("engraving-input");
    if (this.engravingInput) {
      this.engravingInput.addEventListener(
        "input",
        this.validateEngraving.bind(this)
      );
    }


  }

  updatePrice() {
    const selectedSize = this.ringSizeSelect.value;
    const selectedVariant = this.ring.variants.find(
      (variant) => variant.option1 === selectedSize
    );

    if (selectedVariant) {
      this.ring.price = (
        (parseFloat(selectedVariant.price) / 100) *
        this.conversionRate
      ).toFixed(2); // RECONVERSION NEEDED
      this.totalPrice =
        parseFloat(this.diamond.price) + parseFloat(this.ring.price); // Both already adjusted for fx

      this.displayUpdatedPrice();
    }
  }

  validateEngraving(event) {
    const input = event.target;
    input.value = input.value.slice(0, 10);
  }

  displayUpdatedPrice() {
    document.getElementById("ring-price").textContent = `${Shopify.currency.active
      } $${parseFloat(this.ring.price).toLocaleString()}`;
    document.getElementById("total-sum").textContent = `${Shopify.currency.active
      } $${parseFloat(this.totalPrice).toLocaleString()}`;
  }

  async addToCart() {

    if (!this.ringSizeSelect) {
      return;
    }

    const ringSize = this.ringSizeSelect.value;
    const engraving = this.engravingInput.value.trim();

    if (!ringSize) {
      const msg = "A perfect fit awaits—select your ring size.";
      this.ringSizeSelect.setCustomValidity(msg);
      this.showRingSizeError(msg);
      this.ringSizeSelect.focus({ preventScroll: false });
      return;
    }

    // clear any stale error
    this.ringSizeSelect.setCustomValidity("");
    this.clearRingSizeError();


    try {
      this.spinnerOverlayManager.show();
      await this.cartManager.completeYourRing({
        diamond: this.diamond,
        ring: {
          ...this.ring,
          selectedSize: ringSize,
          engraving: engraving,
          variantImgURL: this.ring.mainImage,
        },
      });
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert("Failed to add items to cart. Please try again.");
    } finally {
      this.spinnerOverlayManager.hide();
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new RingBuilderStep3();
});
